/* Test-flow catalogus.
   Elke flow = één samenhangend testscenario. Elke stap heeft een stabiele
   id (voor persistente run-status), een label, optionele "als"-rol,
   optioneel een start-URL en optioneel een ghost-doel (username).

   Nieuwe flow toevoegen? Kies een unieke flow.id + stabiele step.id (nooit
   hergebruiken tenzij het EXACT dezelfde stap blijft), voeg toe aan
   FLOW_DOMAINS. UI toont ze in de volgorde die je hier opgeeft. */

export const FLOW_DOMAINS = [
  {
    id: 'account',
    label: 'Account & profiel',
    color: 'acid',
    flows: [
      {
        id: 'onboard',
        titel: 'Nieuwe deelnemer — eerste login',
        rol: 'admin + nieuwe user',
        doel: 'Verplichte wachtwoord-wijziging, avatar-upload, bio invullen.',
        start: '/admin?section=live&tab=users',
        stappen: [
          { id: 'reset-pw',     tekst: 'Admin: reset wachtwoord van test.user3 via Gebruikersbeheer' },
          { id: 'ghost-u3',     tekst: 'Ghost naar test.user3 in tweede tab', ghost: 'test.user3' },
          { id: 'force-block',  tekst: 'Verwacht: blokkerend "wachtwoord wijzigen"-scherm' },
          { id: 'set-new-pw',   tekst: 'Kies nieuw wachtwoord, submit — server moet naar home doorsturen' },
          { id: 'avatar',       tekst: 'Ga naar /profile → upload avatar' },
          { id: 'bio',          tekst: 'Vul bio + 2 favoriete games in, opslaan' },
          { id: 'verify-list',  tekst: 'Terug als admin: ga naar /spelers — nieuwe avatar + bio moeten zichtbaar zijn' },
        ],
      },
      {
        id: 'voor-mij',
        titel: 'Home & "Voor mij"-tijdlijn',
        rol: 'deelnemer',
        doel: 'Persoonlijke hero moet zich aanpassen aan wat er speelt.',
        start: '/',
        stappen: [
          { id: 'baseline',     tekst: 'Ghost naar test.user1 met leeg schema — home toont "geen actie nodig"', ghost: 'test.user1' },
          { id: 'invite',       tekst: 'Als admin: stuur team-invite naar test.user1' },
          { id: 'invite-hero',  tekst: 'Bij test.user1: home-hero moet uitnodigings-tegel tonen' },
          { id: 'match-open',   tekst: 'Start een toernooi waar test.user1 in zit — hero moet naar "match staat open" wisselen' },
          { id: 'live-slot',    tekst: 'Voeg programma-slot toe dat nu bezig is — LiveNowHero moet dit tonen' },
        ],
      },
      {
        id: 'home-widgets',
        titel: 'Home-widgets: quick-strip + Bar & Raffle',
        rol: 'deelnemer',
        doel: 'HomeQuickStrip toont tegels bij data, verbergt zich bij lege response. Raffle-widget verschijnt naast Kassa met progress-bar.',
        start: '/',
        stappen: [
          { id: 'empty-baseline',    tekst: 'Ghost naar test.user1 zonder next-match, geen upcoming slot — QuickStrip verbergt zich volledig als er ook geen online users zijn', ghost: 'test.user1' },
          { id: 'slot',              tekst: 'Als admin: voeg programma-slot toe met start over ~10 min via /programma-admin' },
          { id: 'slot-tile',         tekst: 'Bij test.user1: "Volgende programma"-tegel toont slot-titel + "over Xm"' },
          { id: 'match-setup',       tekst: 'Admin: schrijf test.user1 in bij een lopend toernooi, koppel aan een pending match' },
          { id: 'match-tile',        tekst: 'Bij test.user1: "Jouw volgende match"-tegel verschijnt (met acid border-left)' },
          { id: 'online',            tekst: 'Log als 2e user in op tweede tab — "Online"-tegel toont ≥ 2 spelers' },
          { id: 'kassa-widget',      tekst: 'Onderaan: Bar & Bestellen kaart (blauw) — top-drinkers zichtbaar of "nog geen bestellingen"' },
          { id: 'raffle-widget',     tekst: 'Naast Bar: Raffle-tickets kaart (geel) toont count + progress-bar naar volgende ticket' },
          { id: 'raffle-progress',   tekst: 'Bestel iets via kassa — progress-bar moet mee-groeien, "tot volgende ticket" moet dalen' },
          { id: 'raffle-inleveren',  tekst: 'Verifieer tekst: "Tickets inleveren bij een compo-admin tijdens de trekking." — GEEN verwijzing naar prijzenkraam' },
          { id: 'announcement-live', tekst: 'Verifieer: aankondiging staat ALLEEN in "Van de organisator", NIET meer als tile in "Wat leeft er nu"' },
        ],
      },
      {
        id: 'profile',
        titel: 'Steam-profiel + badges + loadout',
        rol: 'deelnemer',
        doel: 'Profielpagina, badge-verwerving en loadout wissel.',
        start: '/profile',
        stappen: [
          { id: 'open',         tekst: 'Ghost naar test.user1 → open /profile', ghost: 'test.user1' },
          { id: 'edit-banner',  tekst: 'Kies een banner uit inventaris (of bevestig lege inventaris = ok)' },
          { id: 'edit-frame',   tekst: 'Kies avatar-frame; controleer preview' },
          { id: 'edit-accent',  tekst: 'Kies accent-kleur — banner-tekst moet mee-veranderen' },
          { id: 'admin-badge',  tekst: 'Admin: ken een badge toe via /admin/badges' },
          { id: 'user-badge',   tekst: 'Bij user: badge moet verschijnen op profiel + notificatie' },
          { id: 'auto-item',    tekst: 'Als badge item-grant heeft: profielitem moet in inventaris komen' },
        ],
      },
    ],
  },
  {
    id: 'teams',
    label: 'Teams & sociaal',
    color: 'acid',
    flows: [
      {
        id: 'team-create',
        titel: 'Team aanmaken + leden werven',
        rol: 'deelnemer als kapitein',
        doel: 'Team-flow zonder admin: invite, aanvraag, kapitein-overdracht.',
        start: '/teams',
        stappen: [
          { id: 'create',       tekst: 'Ghost naar test.user1 → /teams → maak team "TestTeam"', ghost: 'test.user1' },
          { id: 'invite',       tekst: 'Nodig test.user2 uit vanuit team-detail' },
          { id: 'invite-inbox', tekst: 'Ghost naar test.user2 → /mijn-verzoeken — invite moet er staan', ghost: 'test.user2' },
          { id: 'accept',       tekst: 'test.user2 accepteert — moet in team verschijnen' },
          { id: 'request',      tekst: 'Ghost naar test.user4 → vraag lidmaatschap aan bij TestTeam', ghost: 'test.user4' },
          { id: 'approve',      tekst: 'Kapitein (user1) keurt verzoek goed via inbox' },
          { id: 'transfer',     tekst: 'Kapitein (user1) draagt kapitein-rol over aan user2' },
          { id: 'verify-role',  tekst: 'user2 moet nu kapitein-badge tonen; user1 gewoon lid' },
        ],
      },
      {
        id: 'spelers-browser',
        titel: 'Spelers-lijst + publiek profiel',
        rol: 'deelnemer',
        doel: 'Community-browser met filter, publiek profiel klikbaar overal.',
        start: '/spelers',
        stappen: [
          { id: 'open',         tekst: 'Open /spelers, zoek op "test"' },
          { id: 'click-profile',tekst: 'Klik een test-user aan → profielpagina moet open klikbaar zijn' },
          { id: 'from-team',    tekst: 'Vanaf team-detailpagina: klik op een lid — moet ook naar profiel' },
          { id: 'from-bracket', tekst: 'Vanaf toernooi-bracket: klik op een spelernaam — profiel opent' },
        ],
      },
    ],
  },
  {
    id: 'tournaments',
    label: 'Toernooien',
    color: 'gold',
    flows: [
      {
        id: 'tour-single',
        titel: 'Single elim — full lifecycle',
        rol: 'admin + spelers',
        doel: 'Nieuw toernooi, inschrijvingen, bracket, matches, uitreiking.',
        start: '/tournaments',
        stappen: [
          { id: 'create',       tekst: 'Admin: /tournaments → maak toernooi "T-Single" (single_elim, max 4, points 10/5/3)' },
          { id: 'reg-open',     tekst: 'Zet status op "registration"' },
          { id: 'reg-u1',       tekst: 'Ghost user1 → schrijf in als solo', ghost: 'test.user1' },
          { id: 'reg-u2',       tekst: 'Ghost user2 → schrijf in', ghost: 'test.user2' },
          { id: 'reg-u3',       tekst: 'Ghost user3 → schrijf in', ghost: 'test.user3' },
          { id: 'reg-u4',       tekst: 'Ghost user4 → schrijf in', ghost: 'test.user4' },
          { id: 'start',        tekst: 'Admin: start toernooi — bracket moet genereren (2 rondes)' },
          { id: 'match1',       tekst: 'Voer winnaar in voor match 1.1' },
          { id: 'match2',       tekst: 'Voer winnaar in voor match 1.2' },
          { id: 'match-final',  tekst: 'Voer winnaar in voor finale' },
          { id: 'award',        tekst: 'Klik "Uitreiken" — punten + evt badge moeten naar spelers' },
          { id: 'verify-points',tekst: 'Bij winnaar: /profile → 10 punten in historiek zichtbaar' },
        ],
      },
      {
        id: 'tour-bo3',
        titel: 'BO3 series — per-game scores',
        rol: 'admin',
        doel: 'Best-of-3 match met game-scores, correct advance.',
        stappen: [
          { id: 'create',       tekst: 'Maak toernooi met best_of=3, 4 deelnemers, single_elim' },
          { id: 'start',        tekst: 'Start bracket' },
          { id: 'match-dialog', tekst: 'Klik op match → dialoog moet per-game score-invoer tonen' },
          { id: 'game1',        tekst: 'Voer game 1 score in (bv 16-14 → team A wint)' },
          { id: 'game2',        tekst: 'Voer game 2 in (team B wint)' },
          { id: 'game3',        tekst: 'Voer game 3 in (winnaar bepaalt match)' },
          { id: 'card-badge',   tekst: 'Bracket-kaart moet "BO3" badge tonen + per-game scores summary' },
        ],
      },
      {
        id: 'tour-swiss',
        titel: 'Swiss system',
        rol: 'admin',
        doel: 'Swiss met meerdere rondes, pairings per stand.',
        stappen: [
          { id: 'create',       tekst: 'Maak toernooi type=swiss, 4 deelnemers, 3 rondes' },
          { id: 'start',        tekst: 'Start — ronde 1 pairings moeten er staan' },
          { id: 'round1',       tekst: 'Voer alle ronde-1 winnaars in' },
          { id: 'next',         tekst: 'Klik "Volgende ronde" in regie — pairings moeten op stand baseren' },
          { id: 'round2',       tekst: 'Voer ronde 2 in' },
          { id: 'round3',       tekst: 'Voer ronde 3 in' },
          { id: 'final-stand',  tekst: 'Eindstand toont ranking op punten + tiebreaker' },
        ],
      },
      {
        id: 'tour-ffa',
        titel: 'FFA (heats) — free-for-all',
        rol: 'admin',
        doel: 'Meerdere heats met plaatsingen per heat.',
        stappen: [
          { id: 'create',       tekst: 'Maak toernooi type=ffa, 6 deelnemers, 2 heats' },
          { id: 'start',        tekst: 'Start — heats moeten gegroepeerd worden' },
          { id: 'scores-h1',   tekst: 'Voer per-speler scores in voor heat 1' },
          { id: 'scores-h2',   tekst: 'Voer per-speler scores in voor heat 2' },
          { id: 'final',       tekst: 'Eindstand: plaatsingen over alle heats gecombineerd' },
        ],
      },
      {
        id: 'tour-regie',
        titel: 'Toernooi-regie dashboard',
        rol: 'admin',
        doel: 'Regie-scherm met stale-alarm, roep-spelers, notes.',
        start: '/regie/toernooien',
        stappen: [
          { id: 'open',         tekst: 'Open /regie/toernooien met minstens 1 actief toernooi' },
          { id: 'live-clock',   tekst: 'Bij lopende match: live-klok moet tikken (mm:ss)' },
          { id: 'call',         tekst: 'Klik "Roep spelers" → notificatie moet aankomen bij deelnemers' },
          { id: 'ready',        tekst: 'Ghost deelnemer → ready-check; regie moet groene dot krijgen', ghost: 'test.user1' },
          { id: 'notes',        tekst: 'Type een ref-notitie, klik weg → moet auto-save' },
          { id: 'stale-alarm',  tekst: 'Laat een match >10 min "in_progress" — stale-tegel + geluid moet triggeren' },
          { id: 'no-show',      tekst: 'Klik "no-show" → tegenstander wint automatisch + advance in bracket' },
        ],
      },
      {
        id: 'tour-filter',
        titel: 'Toernooi-regie — filter-strip',
        rol: 'admin',
        doel: 'Filter zoomt in op één toernooi, banner is duidelijk zichtbaar.',
        start: '/regie/toernooien',
        stappen: [
          { id: 'multi',        tekst: 'Zorg dat er minstens 2 actieve toernooien zijn' },
          { id: 'strip',        tekst: 'Bovenaan verschijnt filter-strip: "Alle (n)" + één knop per toernooi (≤5) of dropdown (>5)' },
          { id: 'click',        tekst: 'Klik een toernooi → knop wordt donker, andere kaarten verdwijnen uit grid' },
          { id: 'banner',       tekst: 'Acid banner "Filter actief: [naam]. Andere toernooien zijn verborgen." + [Wis filter]-knop' },
          { id: 'refresh',      tekst: 'Refresh pagina — filter blijft actief (localStorage)' },
          { id: 'wis',          tekst: 'Klik [Wis filter] → alles terug zichtbaar, banner weg' },
          { id: 'auto-reset',   tekst: 'Als je filter naar toernooi X wijst en toernooi X wordt gearchiveerd: filter reset automatisch' },
        ],
      },
      {
        id: 'tour-uitreiking',
        titel: 'Toernooi uitreiking — badge + prijzen',
        rol: 'admin',
        doel: 'Winner geregistreerd, badge toegekend, prijs vergeven, regie-teller op 0.',
        start: '/tournaments',
        stappen: [
          { id: 'setup',        tekst: 'Open het test-CS-toernooi, doe alle matches af tot winner staat' },
          { id: 'regie-teller', tekst: 'Regie-dashboard: "Toernooien wachten op uitreiking" moet ≥ 1 zijn' },
          { id: 'klik-teller',  tekst: 'Klik teller → land direct op /tournaments/[id]?tab=uitreiking' },
          { id: 'award-badge',  tekst: 'Kies badge in picker → klik "Uitreiken" → winner krijgt badge + notificatie' },
          { id: 'award-prize',  tekst: 'Optioneel: award prijs → prijzenkraam-claim moet verschijnen' },
          { id: 'teller-nul',   tekst: 'Regie-dashboard: teller moet op 0 na award' },
        ],
      },
      {
        id: 'tour-mapveto',
        titel: 'CS 1.6 map-veto (BO1)',
        rol: 'admin + 2 teams',
        doel: 'Ban-flow tot 1 map over, doorschrijven naar bracket-kaart.',
        start: '/regie/servers',
        stappen: [
          { id: 'open',         tekst: 'Open /regie/servers → CS 1.6 kaart → Map-veto' },
          { id: 'link-match',   tekst: 'Kies toernooi + match uit dropdowns — teams moeten auto-invullen' },
          { id: 'create',       tekst: 'Klik "Start map-veto" — nieuwe uuid + share-link' },
          { id: 'ban-a1',       tekst: 'Ghost teamlid A → ban 1 map', ghost: 'test.user1' },
          { id: 'ban-b1',       tekst: 'Ghost teamlid B → ban 1 map', ghost: 'test.user2' },
          { id: 'ban-loop',     tekst: 'Herhaal tot 1 map over blijft' },
          { id: 'winner',       tekst: 'Winner-map moet tonen op sessie-pagina' },
          { id: 'load',         tekst: 'Admin: klik "Load op server" → changelevel commando naar CS server' },
          { id: 'bracket-card', tekst: 'Terug naar toernooi: bracket-kaart toont de map bij de match' },
        ],
      },
    ],
  },
  {
    id: 'shows',
    label: 'Compo\'s & shows',
    color: 'live',
    flows: [
      {
        id: 'kv-full',
        titel: 'Kempenvision — hele show (8 fases)',
        rol: 'admin + jury + deelnemers',
        doel: 'Setup → inschrijving → live → jury → publiek → reveal.',
        start: '/kempenvision',
        stappen: [
          { id: 'setup',        tekst: 'Admin: /kempenvision → nieuwe show, thema + categorieën' },
          { id: 'assign-jury',  tekst: 'Wijs 2 juryleden toe' },
          { id: 'phase-inlever',tekst: 'Zet fase op "Inleveren"' },
          { id: 'submit-1',     tekst: 'Ghost user1 → /kempenvision/inleveren → dien inzending in', ghost: 'test.user1' },
          { id: 'submit-2',     tekst: 'Ghost user2 → dien tweede in', ghost: 'test.user2' },
          { id: 'phase-live',   tekst: 'Admin: fase = "Live nummers"' },
          { id: 'stage',        tekst: 'Open /kempenvision/stage op derde tab — moet live-updates tonen' },
          { id: 'phase-jury',   tekst: 'Fase = "Jury stemmen"' },
          { id: 'jury-vote',    tekst: 'Ghost jury-user → /kempenvision/jury → geef punten', ghost: 'test.referee' },
          { id: 'phase-publiek',tekst: 'Fase = "Publiek stemmen"' },
          { id: 'public-vote',  tekst: 'Ghost user3 → publiek-stem-formulier', ghost: 'test.user3' },
          { id: 'phase-reveal', tekst: 'Fase = "Reveal" — winner-animatie + puntentelling' },
          { id: 'auto-badge',   tekst: 'Winnaar krijgt automatisch Kempenvision-winnaar-badge' },
        ],
      },
      {
        id: 'ic-full',
        titel: 'Image Compo — inlever tot reveal',
        rol: 'admin + deelnemers',
        doel: 'Kortere show-flow zonder jury-panel.',
        start: '/imagecompo',
        stappen: [
          { id: 'setup',        tekst: 'Admin: nieuwe image-compo aanmaken' },
          { id: 'phase-inlever',tekst: 'Fase "Inleveren"' },
          { id: 'submit',       tekst: 'Ghost user1 → /imagecompo/inleveren → upload afbeelding', ghost: 'test.user1' },
          { id: 'phase-vote',   tekst: 'Fase = "Publiek stemmen"' },
          { id: 'vote',         tekst: 'Ghost user2 → stem op afbeelding', ghost: 'test.user2' },
          { id: 'phase-reveal', tekst: 'Fase = "Reveal" → stage-view moet winnaar tonen' },
          { id: 'compo-list',   tekst: 'Ga naar /compos → nieuwe uitslag moet in overzicht staan' },
        ],
      },
      {
        id: 'compo-lb',
        titel: 'Compo-overzicht + kruis-leaderboard',
        rol: 'iedereen',
        doel: 'Verzamelplek voor alle compo/toernooi uitslagen.',
        start: '/compos',
        stappen: [
          { id: 'open',         tekst: 'Open /compos — laatste show + toernooi moeten er staan' },
          { id: 'lb',           tekst: 'Toggle naar "Dwars-leaderboard" — top-spelers over alles opgeteld' },
          { id: 'filter',       tekst: 'Filter op LAN-editie — enkel actuele resultaten' },
        ],
      },
      {
        id: 'compo-uitreiking',
        titel: 'Compo uitreiking — deeplink + award',
        rol: 'admin',
        doel: 'Regie-teller "Compo-badges wachten" linkt direct naar juiste admin-tab.',
        start: '/regie',
        stappen: [
          { id: 'setup',        tekst: 'Populate: er staat een test-Kempenvision show op phase=finished, results_awarded_at IS NULL' },
          { id: 'regie-teller', tekst: 'Regie-dashboard: "Compo-badges wachten op toewijzing" toont ≥ 1 (acid)' },
          { id: 'klik',         tekst: 'Klik teller → land op /kempenvision/admin?tab=uitreiking (of imagecompo)' },
          { id: 'tab-open',     tekst: 'Uitreiking-tab moet direct actief zijn (URL deeplink)' },
          { id: 'award',        tekst: 'Voer uitreiking uit: badge-picker + Uitreiken-knop' },
          { id: 'awarded',      tekst: 'results_awarded_at wordt gezet → teller op regie zakt' },
        ],
      },
    ],
  },
  {
    id: 'bar',
    label: 'Bar & economie',
    color: 'peach',
    flows: [
      {
        id: 'bestel',
        titel: 'Bestellen live + KassaHomeWidget',
        rol: '2 deelnemers',
        doel: 'Bestellingen komen live door + top-drinker update.',
        start: '/bestellen',
        stappen: [
          { id: 'a-open',       tekst: 'Ghost user1 in tab A → /bestellen', ghost: 'test.user1' },
          { id: 'b-open',       tekst: 'Ghost user2 in tab B → /bestellen', ghost: 'test.user2' },
          { id: 'a-order',      tekst: 'Tab A: plaats bestelling van iets uit menu' },
          { id: 'b-live',       tekst: 'Tab B: aantal-bestellingen tegel moet auto-updaten zonder refresh' },
          { id: 'a-saldo',      tekst: 'Tab A: openstaand saldo moet stijgen; ga naar /kassa/mij' },
          { id: 'a-home-widget',tekst: 'Tab A: op home moet KassaHomeWidget nieuwe saldo tonen' },
        ],
      },
      {
        id: 'prizes',
        titel: 'Prijzenkraam — claim + historiek',
        rol: 'admin + deelnemer',
        doel: 'Punten inruilen, atomic claim, audit-log check.',
        start: '/prijzenkraam',
        stappen: [
          { id: 'seed',         tekst: 'Admin: /prijzenkraam/admin → controleer of 22 prijzen geseed zijn' },
          { id: 'points',       tekst: 'Admin: geef test.user1 handmatig 500 punten' },
          { id: 'claim',        tekst: 'Ghost user1 → /prijzenkraam → claim een prijs die zij kunnen betalen', ghost: 'test.user1' },
          { id: 'saldo',        tekst: 'user1: puntensaldo moet gedaald zijn met de kostprijs' },
          { id: 'stock',        tekst: 'Admin: voorraad van die prijs moet met 1 gezakt zijn' },
          { id: 'history',      tekst: 'Admin: /prijzenkraam/admin → historiek-tab → claim moet er staan met "god geeft prijs mee aan user1"' },
          { id: 'annuleer',     tekst: 'Annuleer die claim vanaf admin → punten terug + stock terug' },
          { id: 'history-cancel',tekst: 'Historiek moet ook de annulatie loggen' },
        ],
      },
      {
        id: 'raffle',
        titel: 'Raffle-tickets — home-widget + progress + trekking',
        rol: 'admin + user',
        doel: 'RaffleHomeWidget toont count + progress; teller uit kassa; tekst zegt "inleveren bij compo-admin".',
        start: '/',
        stappen: [
          { id: 'admin-page',   tekst: 'Admin: /admin/raffle → instellingen zichtbaar (threshold cents)' },
          { id: 'seeded',       tekst: 'Populate zet 3-5 tickets per user1..5 → user1 heeft er 5' },
          { id: 'ghost',        tekst: 'Ghost naar test.user1 → home', ghost: 'test.user1' },
          { id: 'kassa-widget', tekst: 'Onderaan: Bar & Bestellen + Raffle-tickets naast elkaar (max-w-2xl grid)' },
          { id: 'raffle-count', tekst: 'RaffleHomeWidget toont "5 tickets" groot, geel accent' },
          { id: 'progress-bar', tekst: 'Progress-bar richting volgende ticket + "€X,XX tot volgende"' },
          { id: 'spent-line',   tekst: 'Onder progress: "Besteed: €X · 1 ticket per €10"' },
          { id: 'text-fix',     tekst: 'Onderste regel: "Tickets inleveren bij een compo-admin tijdens de trekking." — GEEN verwijzing naar prijzenkraam' },
          { id: 'order-live',   tekst: 'Ghost admin, plaats bestelling voor user1 → cents_to_next daalt bij volgende widget-poll (60s)' },
          { id: 'regie-teller', tekst: 'Admin: /regie → "Raffle-tickets vandaag" telt de tickets die vandaag zijn gegund' },
        ],
      },
    ],
  },
  {
    id: 'servers',
    label: 'Gameservers & regie',
    color: 'slate',
    flows: [
      {
        id: 'srv-browser',
        titel: 'Game-servers browser + zichtbaarheid',
        rol: 'admin + deelnemer',
        doel: 'Deelnemer ziet enkel zichtbare servers.',
        start: '/game-servers',
        stappen: [
          { id: 'admin-open',   tekst: 'Admin: /game-servers → alle servers zichtbaar' },
          { id: 'hide',         tekst: 'Verberg 1 server via toggle' },
          { id: 'user-list',    tekst: 'Ghost user1 → /game-servers → verborgen server mag NIET zichtbaar zijn', ghost: 'test.user1' },
          { id: 'connect-copy', tekst: 'user1: klik "Kopieer connect" — clipboard moet cmd bevatten' },
          { id: 'reset',        tekst: 'Admin: zet server terug op zichtbaar' },
        ],
      },
      {
        id: 'srv-3-cs16',
        titel: 'CS 1.6 servers — Compo 1/2 + Freeplay bereikbaar',
        rol: 'admin',
        doel: 'Alle 3 CS-servers werken (27015/27016/27018), status online in regie.',
        start: '/game-servers',
        stappen: [
          { id: 'lijst',       tekst: 'Ghost user of admin → /game-servers → 3 rijen: Compo 1 (27015), Compo 2 (27016), Freeplay (27018)' },
          { id: 'connect-1',   tekst: 'Klik "Kopieer connect" op Compo 1 → verwacht: connect 192.168.129.173:27015' },
          { id: 'regie-online',tekst: 'Regie-dashboard: geen "gameserver offline"-warning voor de 3 CS-servers' },
          { id: 'rcon',        tekst: 'Test RCON: rcon_password test1234 → rcon status geeft speler-lijst met bots' },
          { id: 'bots',        tekst: 'Op Freeplay: 8 YaPB-bots automatisch aanwezig (yb_quota 8)' },
          { id: 'mp',          tekst: 'Compo 1/2: bb_match plugin actief → .ready-cmd start ready-check' },
        ],
      },
      {
        id: 'srv-bot-panel',
        titel: 'CS 1.6 bot-panel — YaPB controls',
        rol: 'admin',
        doel: 'Bot-quota, difficulty, kick vanuit ServerRegiePage werkt via RCON.',
        start: '/regie/servers',
        stappen: [
          { id: 'open',        tekst: 'Open /regie/servers → klap CS 1.6 Compo 1 open → scroll naar "Bots (YaPB)"-card' },
          { id: 'add-ct',      tekst: 'Klik "+ CT bot" → aantal in scoreboard stijgt met 1 CT-bot' },
          { id: 'quota',       tekst: 'Zet Quota op 4 → aantal bots stabiliseert op 4' },
          { id: 'autofill-on', tekst: 'Klik "Auto-fill aan" → bots vullen aan tot maxplayers' },
          { id: 'difficulty',  tekst: 'Klik "Expert" → yb_difficulty 4 gaat naar server' },
          { id: 'team-ct',     tekst: 'Klik "Alleen CT" → yb_join_team CT: nieuwe bots joinen enkel CT' },
          { id: 'autokill',    tekst: 'Zet "Auto-kick bij real players" aan → als user1 joint, moet een bot gekickt worden' },
          { id: 'kick-all',    tekst: 'Klik "Kick alle bots" → yb kickbots → scoreboard leeg (behalve real)' },
        ],
      },
      {
        id: 'srv-regie',
        titel: 'Server-regie + RCON',
        rol: 'admin',
        doel: 'Changelevel + console-cmd naar CS 1.6.',
        start: '/regie/servers',
        stappen: [
          { id: 'open',         tekst: 'Open /regie/servers, klik CS 1.6 kaart open' },
          { id: 'changelevel',  tekst: 'Kies map uit dropdown → verwacht: server changelevel binnen enkele seconden' },
          { id: 'console',      tekst: 'Type een RCON-cmd (bv. status) → output moet in console-log verschijnen' },
          { id: 'restart',      tekst: 'Optioneel: klik restart → status moet naar "starting" gaan' },
        ],
      },
      {
        id: 'cs16-full',
        titel: 'CS 1.6 — Red-Banana egg full flow',
        rol: 'admin + speler',
        doel: 'Test de nieuwe CS 1.6-test-server (id 25, 44d45e65, poort 25566) end-to-end: connect + bots + overlay + match-plugin + first-to-8.',
        start: '/regie/servers',
        stappen: [
          { id: 'server-up',     tekst: 'Admin: check via /regie/servers of "CS 1.6 Test (Red-Banana)" ONLINE staat' },
          { id: 'connect',       tekst: 'Open CS 1.6 → console → connect 192.168.129.173:25566' },
          { id: 'ingame',        tekst: 'Kies team CT of T, spawn — check dat je "Fullserver"/eigen naam ziet in scoreboard (Tab)' },
          { id: 'rcon-login',    tekst: 'In console: rcon_password test1234 → rcon status → speler-list moet volgen' },
          { id: 'yb-add',        tekst: 'rcon yb fill_server → 12+ bots joinen automatisch CT/T verdeeld' },
          { id: 'kill-someone',  tekst: 'Speel een ronde, dood minstens 1 bot met vuurwapen + 1 met headshot' },

          { id: 'overlay-link',  tekst: 'Ga naar /schermregie → OBS-overlay kanaal "main" → Game-server dropdown: kies "CS 1.6 Test (Red-Banana)"' },
          { id: 'overlay-open',  tekst: 'Open /overlay/channel/main?debug=1 in nieuw tab. Linksboven: "● connected · ch:main → CS 1.6 Test → ..."' },
          { id: 'overlay-strips',tekst: 'CT-strip links (blauw) en T-strip rechts (oranje) moeten spelers tonen met naam + frags/deaths + ping' },
          { id: 'overlay-scoreboard', tekst: 'Bovenaan: CT-getal · map · T-getal — updaten na elke gewonnen ronde (2-4s delay is normaal)' },
          { id: 'overlay-killfeed',   tekst: 'Rechtsboven: kill-feed — laatste 8 kills, team-kleur op namen, roze dot bij headshot, nieuw ONDERAAN' },

          { id: 'match-warmup',  tekst: 'Check HUD linksboven in-game: "[BB Match] WARMUP - CT 0/X ready | T 0/Y ready"' },
          { id: 'match-ready',   tekst: 'Type in chat: .ready → HUD update naar "1/X ready". Type .unready → terug 0.' },
          { id: 'match-live',    tekst: 'Alternatief (met bots ready is niet triviaal): rcon amx_live → HUD wisselt naar "LIVE ronde 1/15 - first to 8"' },
          { id: 'match-scores',  tekst: 'Speel 2-3 rondes, kijk of ronde-teller op HUD én score op overlay meestijgt' },

          { id: 'sideswap',      tekst: 'Speel 7 rondes (of manipuleer via mp_forcerespawn + mp_freezetime 0 om snel te winnen). Bij ronde 8: chat toont "[BB] SIDE-SWITCH! Teams wisselen in 5s..."' },
          { id: 'swap-teams',    tekst: 'Na de swap: je zit op de andere kant (CT ↔ T). Bots wisselen ook.' },
          { id: 'swap-scores',   tekst: 'BELANGRIJKE CHECK: als voor swap CT 5-2 stond, moet na swap CT 2-5 zijn (score verhuisde MET de spelers). Zie ct=/t= in BB_OVERLAY log of overlay scoreboard.' },

          { id: 'first-to-8',    tekst: 'Speel door tot iemand 8 rondes wint. Match moet automatisch eindigen (mp_winlimit 8).' },
          { id: 'end-restart',   tekst: 'Na match-end: rcon amx_warmup → server terug in warmup-mode (HUD toont "WARMUP")' },

          { id: 'mapveto',       tekst: '/regie/servers → CS 1.6 kaart → Map-veto: kies toernooi + match + Start map-veto. Doorloop bans → gekozen map verschijnt op bracket-kaart.' },
          { id: 'load-on-server',tekst: 'In mapveto-detail: klik "Load op server" → server changelevel-t naar gekozen map (verwacht: rcon changelevel <map>)' },
          { id: 'admin-menu',    tekst: 'In-game: type "amxmodmenu" in console → AMXX admin-menu opent (jij bent admin met SteamID STEAM_2:1:568777417)' },
          { id: 'kick-bot',      tekst: 'Test admin: kick een bot via menu (Player commands → Kick) → bot verdwijnt' },

          { id: 'udp-live',      tekst: 'Ronde-score binnen ~200ms na round-end op overlay (niet 3s zoals bij pure file-poll) — verifieert UDP-pad' },
          { id: 'udp-mapping',   tekst: 'Multi-server: Compo 2 kan tegelijk lopen; overlay Compo 1 mag NIET Compo 2\'s score tonen (ip+port-mapping werkt)' },
          { id: 'kd-live',       tekst: 'K/D-counters in de strips groeien real-time (delta uit UDP-kills) — resetten bij elke amx_status baseline (~15s)' },
        ],
      },
      {
        id: 'wreckfest',
        titel: 'Wreckfest — regie + event loop',
        rol: 'admin',
        doel: 'Config-editor, playlist, preset opslaan/importeren.',
        start: '/regie/wreckfest',
        stappen: [
          { id: 'open',         tekst: 'Open /regie/wreckfest — huidige config-values moeten geladen zijn' },
          { id: 'edit',         tekst: 'Verander game_mode via editor, opslaan → verwacht: server_config.cfg bijgewerkt' },
          { id: 'loop-add',     tekst: 'Voeg 3 tracks toe aan event loop' },
          { id: 'loop-save',    tekst: 'Sla loop op als preset "TestLoop"' },
          { id: 'preset-switch',tekst: 'Wissel naar andere preset — event loop moet mee-veranderen' },
          { id: 'server-check', tekst: 'Verwacht: server ontvangt cfg-update bij volgende restart' },
        ],
      },
    ],
  },
  {
    id: 'screens',
    label: 'Schermen & zaal',
    color: 'acid',
    flows: [
      {
        id: 'schermregie',
        titel: 'Schermregie — presets + scenes',
        rol: 'admin',
        doel: 'Twee virtuele beamers bedienen, preset opslaan.',
        start: '/schermregie',
        stappen: [
          { id: 'open-b1',      tekst: 'Open in tab B: /scherm/test-beamer-1' },
          { id: 'open-b2',      tekst: 'Open in tab C: /scherm/test-beamer-2' },
          { id: 'regie-open',   tekst: 'Tab A: /schermregie — beide beamers moeten in de lijst staan' },
          { id: 'push-a',       tekst: 'Push /zaal/welkom naar beamer-1 → tab B moet spring naar welkom-view' },
          { id: 'push-b',       tekst: 'Push /zaal/bar naar beamer-2 → tab C wisselt' },
          { id: 'preset-save',  tekst: 'Sla stand op als preset "start-avond"' },
          { id: 'reset',        tekst: 'Verander beide beamers naar iets anders' },
          { id: 'preset-load',  tekst: 'Klik preset "start-avond" — beide moeten terug switchen' },
          { id: 'color',        tekst: 'Verander accent-kleur van beamer-1 → visueel op tab B' },
        ],
      },
      {
        id: 'midi-streamdeck',
        titel: 'MIDI + Streamdeck triggers',
        rol: 'admin',
        doel: 'Fysieke controllers activeren scene-switches.',
        stappen: [
          { id: 'midi-config',  tekst: 'Optioneel: sluit APC/LPD8 aan → herkend in schermregie sidebar-badge?' },
          { id: 'midi-pad',     tekst: 'Druk een gemapped pad → verwacht: preset schakelt' },
          { id: 'led-fb',       tekst: 'LPD8 mk2: LED van actieve pad moet oplichten' },
          { id: 'streamdeck-t', tekst: 'Streamdeck: druk knop → generic-http moet aankomen bij /streamdeck/trigger' },
          { id: 'token-warn',   tekst: 'Als default-token gebruikt: banner moet waarschuwing tonen aan admin' },
        ],
      },
      {
        id: 'obs-setup',
        titel: 'OBS — koppelen + scene-picker + MIDI-binding',
        rol: 'admin',
        doel: 'Nieuwe OBS-PC toevoegen, verbinding testen, scenes switchen vanuit web + MIDI.',
        start: '/schermregie',
        stappen: [
          { id: 'obs-panel',    tekst: 'Scroll naar "OBS-verbindingen" onderaan schermregie' },
          { id: 'add-new',      tekst: 'Klik "Nieuwe OBS" → inline form (geen popup) opent boven de lijst' },
          { id: 'fill',         tekst: 'Vul Label / IP / Poort 4455 / WebSocket-wachtwoord in en klik Aanmaken' },
          { id: 'live-green',   tekst: 'Nieuwe rij verschijnt met groen wifi-icoon binnen ~5s (of rood + Test-knop tonen bij foute creds)' },
          { id: 'test',         tekst: 'Klik Test → alert met OBS-versie + aantal scenes' },
          { id: 'edit',         tekst: 'Klik Bewerk → inline form, pas Label aan, opslaan → naam in header verandert' },
          { id: 'scenes',       tekst: 'Onder de instance: knopjes per scene (donker = huidige). Klik een andere → OBS wisselt live' },
          { id: 'midi-learn',   tekst: '(indien MIDI aangesloten) Klik muzieknoot-icoon naast scene → wacht op MIDI-druk → pluspaars met notenummer' },
          { id: 'midi-trigger', tekst: 'Druk de gekoppelde MIDI-knop → OBS switcht naar die scene' },
          { id: 'midi-unbind',  tekst: 'Klik notenummer opnieuw → binding weg' },
          { id: 'reconnect',    tekst: 'Klik Reconnect → status blijft groen (herbouwt verbinding)' },
          { id: 'delete',       tekst: 'Klik verwijderen → confirm-dialog → rij weg' },
        ],
      },
      {
        id: 'zaal-views',
        titel: 'Zaal-views — alle 6 klikken',
        rol: 'iedereen',
        doel: 'Snel visuele check op alle projectie-URLs.',
        stappen: [
          { id: 'welkom',       tekst: 'Open /zaal/welkom — LAN-branding + welkomsttekst' },
          { id: 'bar',          tekst: 'Open /zaal/bar — actueel menu + top-drinkers' },
          { id: 'nu',           tekst: 'Open /zaal/nu — programma-slot nu + straks' },
          { id: 'scores',       tekst: 'Open /zaal/scores — leaderboards' },
          { id: 'servers',      tekst: 'Open /zaal/servers — gameserver-status' },
          { id: 'toernooi',     tekst: 'Open /zaal/toernooi — live bracket' },
        ],
      },
    ],
  },
  {
    id: 'community',
    label: 'Community & beheer',
    color: 'acid',
    flows: [
      {
        id: 'feedback',
        titel: 'Feedback-bus (bug/idee)',
        rol: 'deelnemer + admin',
        doel: 'Indienen, upvote, admin-comments, roadmap.',
        start: '/feedback',
        stappen: [
          { id: 'submit',       tekst: 'Ghost user1 → /feedback → dien "Test bug X" in met screenshot', ghost: 'test.user1' },
          { id: 'mine',         tekst: 'Tab "Mijn" — nieuwe item moet er staan' },
          { id: 'admin-list',   tekst: 'Admin: /admin?tab=feedback — nieuwe item in inbox' },
          { id: 'admin-status', tekst: 'Zet status op "planned" + admin_note' },
          { id: 'roadmap',      tekst: 'Ghost user2 → /feedback → tab Roadmap — item moet publiek staan', ghost: 'test.user2' },
          { id: 'upvote',       tekst: 'user2 upvote — teller +1' },
          { id: 'comment1',     tekst: 'Admin: reageer op ticket' },
          { id: 'comment2',     tekst: 'Admin: reageer nog een 2e keer (feature moet multi-comment kunnen)' },
          { id: 'user-see',     tekst: 'user1: ziet beide admin-comments in thread' },
        ],
      },
      {
        id: 'helpdesk',
        titel: 'Helpdesk — ticket + panel',
        rol: 'deelnemer + helpdesk',
        doel: 'Ticket openen, helpdesk-rol werkt los van admin.',
        start: '/helpdesk',
        stappen: [
          { id: 'open',         tekst: 'Ghost user1 → /helpdesk → open ticket "Test ticket"', ghost: 'test.user1' },
          { id: 'panel',        tekst: 'Ghost test.help → /helpdesk-panel — ticket moet zichtbaar zijn', ghost: 'test.help' },
          { id: 'assign',       tekst: 'Helpdesk claimt ticket → moet in "mijn tickets" verschijnen' },
          { id: 'respond',      tekst: 'Helpdesk beantwoordt — user1 krijgt notificatie' },
          { id: 'close',        tekst: 'Sluit ticket — status "gesloten"' },
        ],
      },
      {
        id: 'wiki',
        titel: 'Wiki — schrijven + zichtbaarheid',
        rol: 'admin + user',
        doel: 'Admin-only en admin+user zichtbaarheids-slider.',
        start: '/wiki',
        stappen: [
          { id: 'create',       tekst: 'Admin: /wiki → nieuw artikel "TestArtikel" met markdown-body' },
          { id: 'visibility',   tekst: 'Zet zichtbaarheid op "admin only"' },
          { id: 'user-not-see', tekst: 'Ghost user1 → /wiki → artikel mag NIET zichtbaar zijn', ghost: 'test.user1' },
          { id: 'toggle',       tekst: 'Admin: zichtbaarheid → "admin+user"' },
          { id: 'user-see',     tekst: 'user1 refresh — artikel moet nu wél in lijst staan' },
          { id: 'delete',       tekst: 'Admin: verwijder testartikel' },
        ],
      },
      {
        id: 'menu-structure',
        titel: 'Menu / sidebar — nieuwe structuur',
        rol: 'admin + user',
        doel: 'Sidebar-secties in correcte volgorde, Beheer inklapbaar, Kaarten-tab in beide admin-secties.',
        start: '/',
        stappen: [
          { id: 'volgorde',      tekst: 'Sidebar bovenaan → onder: Home · Nu op de LAN · Toernooien · Spelen · Bar · Community · Extra\'s · Helpdesk · Regie · Helpdesk-beheer · Beheer' },
          { id: 'toernooien',    tekst: '"Toernooien"-sectie: Toernooien / Compo-uitslagen / Kempenvision / Image Compo' },
          { id: 'spelen',        tekst: '"Spelen"-sectie: Mini-games / Game-servers / Game-bestanden (géén Teams meer, géén Ranking meer)' },
          { id: 'community',     tekst: '"Community"-sectie bevat Teams + Ranking (verplaatst)' },
          { id: 'helpdesk',      tekst: '"Helpdesk"-sectie bevat: Helpdesk + Wiki + Bug/idee' },
          { id: 'regie',         tekst: '"Regie"-sectie tussen Community en Beheer: Regie / Toernooi-regie / Server-regie / Schermregie / Raffle-tickets' },
          { id: 'beheer-fold',   tekst: '"Beheer" heeft chevron-icoontje rechts van header → klik: sectie klapt in, chevron draait 90°' },
          { id: 'beheer-persist',tekst: 'Refresh pagina — Beheer blijft ingeklapt (localStorage)' },
          { id: 'kaarten-live',  tekst: '/admin?section=live → tabstrip bevat "Kaarten" — klik → blijft in Live sectie (springt NIET naar Setup)' },
          { id: 'kaarten-setup', tekst: '/admin?section=setup → tabstrip bevat "Kaarten" — klik → blijft in Setup' },
          { id: 'nieuws-name',   tekst: 'Nieuws in sidebar heet gewoon "Nieuws" (niet "Nieuws / notifications")' },
        ],
      },
      {
        id: 'regie-blokken',
        titel: 'Regie-dashboard — 3 nieuwe blokken',
        rol: 'admin',
        doel: 'Compo\'s & uitreiking / Bar & kassa / Deelnemers tonen echte data + snelknoppen.',
        start: '/regie',
        stappen: [
          { id: 'compo-titel',   tekst: 'Blok heet "Compo\'s & uitreiking" (niet meer alleen "Shows")' },
          { id: 'next-phase',    tekst: 'Bij actieve Kempenvision-show: knopje "→ [volgende fase]" naast status; klik → phase updatet direct' },
          { id: 'award-teller',  tekst: 'Compo-badges wachten: teller ≥ 1 (uit populate) + acid; klik → /kempenvision/admin?tab=uitreiking of imagecompo/admin?tab=uitreiking' },
          { id: 'tour-teller',   tekst: 'Toernooien wachten op uitreiking: klik → direct naar toernooi-detail?tab=uitreiking' },
          { id: 'bar-blok',      tekst: '"Bar & kassa"-blok: Event + Besteld vandaag (€) + Open rekeningen (unieke personen!) + Raffle-tickets vandaag' },
          { id: 'bar-top3',      tekst: 'Onder Bar: "Top-drinkers" lijst met 3 personen (niet meer 1)' },
          { id: 'unieke',        tekst: 'Test unieke rekeningen: geef god 4 open rekeningen + user1 1 → teller = 2 (niet 5)' },
          { id: 'deel-blok',     tekst: '"Deelnemers"-blok: Online laatste uur / Team-verzoeken open / Onbeantwoorde tickets' },
          { id: 'deel-invite',   tekst: 'Team-verzoeken open ≥ 1 (uit populate) + acid; klik → /teams' },
          { id: 'deel-ticket',   tekst: 'Onbeantwoorde tickets ≥ 1 (uit populate) + acid; klik → /helpdesk-panel' },
        ],
      },
      {
        id: 'users-admin',
        titel: 'Gebruikersbeheer + rollen',
        rol: 'admin',
        doel: 'Rol wisselen, wachtwoord resetten, verwijderen.',
        start: '/admin?section=live&tab=users',
        stappen: [
          { id: 'open',         tekst: 'Open Gebruikersbeheer — test-users moeten in lijst' },
          { id: 'promote',      tekst: 'Zet test.user4 rol op referee → verwacht: badge verandert' },
          { id: 'reset',        tekst: 'Klik "Reset wachtwoord" bij test.user4 → nieuw wachtwoord getoond' },
          { id: 'demote',       tekst: 'Zet test.user4 rol terug op user' },
        ],
      },
      {
        id: 'health',
        titel: 'System health + Funnel + failed logins',
        rol: 'admin',
        doel: 'Monitor-panels tonen live data, toggles werken.',
        start: '/admin/system-health',
        stappen: [
          { id: 'health',       tekst: 'Open /admin/system-health — CPU/mem/disk moet tonen voor lanserver + Pterodactyl' },
          { id: 'disks',        tekst: 'Disks-panel niet leeg — waarschuwing bij >90%' },
          { id: 'failed-login', tekst: 'Admin: /admin?tab=failed-logins — verdachte IPs paneel' },
          { id: 'try-bad',      tekst: 'Probeer 3× foute login → moet in log verschijnen' },
          { id: 'funnel',       tekst: 'Admin: Funnel-toggle in adminpaneel (LET OP: dit zet publieke modus)' },
          { id: 'funnel-back',  tekst: 'Zet Funnel weer uit na test' },
        ],
      },
    ],
  },
]

/* Handige helper: alle flows plat gegooid met hun domein-info. */
export function allFlows() {
  const out = []
  for (const d of FLOW_DOMAINS) {
    for (const f of d.flows) {
      out.push({ ...f, domain: d.id, domainLabel: d.label, color: d.color })
    }
  }
  return out
}
